import React from 'react';
import { IconProps } from './model/IconInterface';

const SnowflakeIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="12" y1="2" x2="12" y2="22" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <line x1="4.5" y1="4.5" x2="19.5" y2="19.5" />
      <line x1="19.5" y1="4.5" x2="4.5" y2="19.5" />
      <path d="M12 5 9.5 7.5M12 5l2.5 2.5M12 19l-2.5-2.5M12 19l2.5-2.5" />
      <path d="M5 12 7.5 9.5M5 12l2.5 2.5M19 12l-2.5-2.5M19 12l-2.5 2.5" />
    </svg>
  );
};

export default SnowflakeIcon;
